import moment from 'moment'

export const getToday = () => {
	return moment().format('YYYY-MM-DD')
}

export const getFiveDaysAgo = () => {
	return moment().subtract(5, 'days').format('YYYY-MM-DD')
}

export const calculateDurationString = (startTime, endTime) => {
	// --- Normalize startTime ---
	let start
	if (/^\d{4}-\d{2}-\d{2}/.test(startTime)) {
		start = moment(startTime, 'YYYY-MM-DD HH:mm:ss')
	} else {
		// Take date from endTime if available, otherwise use today
		const endDatePart = /^\d{4}-\d{2}-\d{2}/.exec(endTime)?.[0]
		const baseDate = endDatePart || moment().format('YYYY-MM-DD')
		start = moment(`${baseDate} ${startTime}`, 'YYYY-MM-DD HH:mm:ss')
	}

	// --- Normalize endTime ---
	let end
	if (/^\d{4}-\d{2}-\d{2}/.test(endTime)) {
		end = moment(endTime, 'YYYY-MM-DD HH:mm:ss')
	} else {
		const startDatePart = /^\d{4}-\d{2}-\d{2}/.exec(startTime)?.[0]
		const baseDate = startDatePart || moment().format('YYYY-MM-DD')
		end = moment(`${baseDate} ${endTime}`, 'YYYY-MM-DD HH:mm:ss')
	}

	// --- Handle next-day scenario ---
	if (end.isBefore(start)) {
		end.add(1, 'day')
	}

	// --- Calculate duration ---
	const duration = moment.duration(end.diff(start))
	const hours = Math.floor(duration.asHours()) // total hours (can be > 24)
	const minutes = duration.minutes()
	const seconds = duration.seconds()

	// --- Format result ---
	return `${hours.toString().padStart(2, '0')}:${minutes
		.toString()
		.padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export const formatTime = (seconds) => {
	const mins = Math.floor(Math.abs(seconds) / 60) * Math.sign(seconds) // Determine minutes with correct sign
	const secs = Math.abs(seconds) % 60 // Always take the absolute value of the remainder

	// Handle the formatting
	const sign = seconds < 0 ? '-' : '' // Determine overall sign
	const formattedMins = Math.abs(mins).toString().padStart(2, '0') // Absolute value of mins
	const formattedSecs = secs.toString().padStart(2, '0') // Always format seconds

	return `${sign}${formattedMins}:${formattedSecs}`
}

export const formatTimeWithHours = (seconds) => {
	const absSeconds = Math.abs(seconds)
	const hours = Math.floor(absSeconds / 3600)
	const mins = Math.floor((absSeconds % 3600) / 60)
	const secs = absSeconds % 60

	// Determine the sign for negative values
	const sign = seconds < 0 ? '-' : ''

	// Format with leading zeros
	const formattedHours = hours.toString().padStart(2, '0')
	const formattedMins = mins.toString().padStart(2, '0')
	const formattedSecs = secs.toString().padStart(2, '0')

	return `${sign}${formattedHours}:${formattedMins}:${formattedSecs}`
}

export const isSameDay = (dueDate, formattedDate = moment()) => {
	return moment(dueDate, 'DD.MM.YYYY').isSame(formattedDate, 'day')
}

export const isBefore = (dueDate, formattedDate = moment()) => {
	return moment(dueDate, 'DD.MM.YYYY').isBefore(formattedDate)
}

export const isAfter = (dueDate, formattedDate = moment()) => {
	return moment(dueDate, 'DD.MM.YYYY').isAfter(formattedDate)
}
